import Vue from 'vue';
import axios from 'axios';

import App from './App.vue'
import store from './store/store';

import localeRoute from './utils/localeRoute';
import fakeApi from '../src/services/MapsfyApi';

Vue.prototype.axios = axios;

import createRouter, { createEventBusManager } from './router'

const router = createRouter(Vue);

import i18n from './i18n';
import RegisterComponents from './plugins/ui';

import Vuelidate from "vuelidate";
Vue.use(Vuelidate)


RegisterComponents();

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    localeRoute: function(location, locale) {
        return localeRoute(location, locale ? locale : i18n.locale);
    }
  }
});

let vueApp;
const getVueApp = () => {
  return vueApp;
};

// eslint-disable-next-line
if (window.$$) {
  // eslint-disable-next-line
  var eventBusManager = createEventBusManager($$, router, getVueApp);
  Vue.prototype.$eventBusManager = eventBusManager;
  router.beforeEach((to, from, next) => {
    eventBusManager.fireUpdate(to, from, next);
  });
} else {
  window.$$ = null;
  window.$$$ = fakeApi();
}

import "@/css/mmTheme.css";
import "@/css/mm-hp-icons.css";

vueApp = new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
